import React, { Suspense, lazy } from 'react';
import { Globals } from '@mabinso-registry/module-commons';
import { Route, Routes } from 'react-router';
import Olap from './olap';
import Dashboard from './dashboard';
import Editors from './editors';
import Multiedit from './multiedit';
import Bildfahrplan from './bildfahrplan';

const cm = (moduleName: string) => {
    console.log('--------------->modules', Globals.modules);
    if (Globals.modules && Globals.modules[moduleName] && Globals.modules[moduleName].jsUrl) {
        console.log('Module found:', moduleName, Globals.modules[moduleName].jsUrl);
        return true;
    }
    return false;
};

const myLazy = (moduleName: string) => {
    return lazy(() => import(cm(moduleName) ? /* @vite-ignore */ Globals.modules[moduleName].jsUrl : './dummy').then(() => ({ default: window[moduleName] })));
};

const CrossAnalytics = myLazy('crossanalytics');

const Editor = myLazy('editor');
// console.log('Module found:', 'etl', Globals.modules['etl'].jsUrl);
//const ETL = lazy(() => import(/* @vite-ignore */ Globals.modules['etl'].jsUrl).then(() => ({ default: window['etl'] })));

const ETL = myLazy('etl');

const Log = myLazy('log');

const ModuleRoutes = ({ ...props }) => (
    <Suspense>
        <Routes>
            <Route path="/module.olap/*" element={<Olap {...props} />} />
            <Route path="/module.multiedit/*" element={<Multiedit {...props} />} />
            <Route path="/module.editors/*" element={<Editors {...props} />} />
            <Route path="/module.bildfahrplan/*" element={<Bildfahrplan {...props} />} />
            <Route path="/module.dashboard/*" element={<Dashboard {...props} />} />
            <Route path="/module.crossanalytics/*" element={<CrossAnalytics {...props} />} />
            <Route path="/module.editor/*" element={<Editor {...props} />} />
            <Route path="/module.etl/*" element={<ETL {...props} globals={Globals} />} />
            <Route path="/module.log/*" element={<Log {...props} />} />
        </Routes>
    </Suspense>
);
export default ModuleRoutes;
